import { Observable } from 'rxjs';

import { UserUsageStats } from '../../../domain/user/user-usage-stats';

export abstract class AppSharedRepositoryPort {
	public abstract observeUserUsageStats(): Observable<UserUsageStats>;

	public abstract saveUserUsageStats(
		userUsageStats: UserUsageStats
	): Promise<void>;

	public abstract saveUserPendingMessages(pendingMessages: {
		[key: string]: number;
	});

	public abstract observeUserPendingMessages(): Observable<{
		[key: string]: number;
	}>;
}
